import React from 'react';
import Scene from './Scene';
import styles from './App.module.css';

function App() {
  return (
    <div className={styles.app}>
      <Scene />
    </div>
  );
}

export default App;
